import * as sharedModels from '@shared/models';

export enum RealPropertyListOrderFields {
  createdDate = 'createdDate',
  totalArea = 'totalArea',
  objectPrice = 'objectPrice',
  numberOfRooms = 'numberOfRooms',
}

export type RealPropertyListOrderOption = {
  label: string;
  orderByFieldId: RealPropertyListOrderFields;
  orderDirection: 'DESC' | 'ASC';
};

export type RawRealPropertyListOrderOption = {
  label: sharedModels.Localization;
  orderByFieldId: RealPropertyListOrderFields;
  orderDirection: 'DESC' | 'ASC';
};

export const RealPropertyListOrderOptions: RawRealPropertyListOrderOption[] = [];

export const RealDatePropertyListOrderOptions: RawRealPropertyListOrderOption[] = [];

export const RealPricePropertyListOrderOptions: RawRealPropertyListOrderOption[] = [];

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'По новизне',
    nameEn: 'По новизне',
    nameKz: 'По новизне',
  },
  orderByFieldId: RealPropertyListOrderFields.createdDate,
  orderDirection: 'DESC',
});

RealDatePropertyListOrderOptions.push({
  label: {
    nameRu: 'По новизне',
    nameEn: 'По новизне',
    nameKz: 'По новизне',
  },
  orderByFieldId: RealPropertyListOrderFields.createdDate,
  orderDirection: 'DESC',
});

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'Цена (по убыванию)',
    nameEn: 'Цена (по убыванию)',
    nameKz: 'Цена (по убыванию)',
  },
  orderByFieldId: RealPropertyListOrderFields.objectPrice,
  orderDirection: 'DESC',
});

RealPricePropertyListOrderOptions.push({
  label: {
    nameRu: 'Цена (по убыванию)',
    nameEn: 'Цена (по убыванию)',
    nameKz: 'Цена (по убыванию)',
  },
  orderByFieldId: RealPropertyListOrderFields.objectPrice,
  orderDirection: 'DESC',
});

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'Цена (по возрастанию)',
    nameEn: 'Цена (по возрастанию)',
    nameKz: 'Цена (по возрастанию)',
  },
  orderByFieldId: RealPropertyListOrderFields.objectPrice,
  orderDirection: 'ASC',
});

RealPricePropertyListOrderOptions.push({
  label: {
    nameRu: 'Цена (по возрастанию)',
    nameEn: 'Цена (по возрастанию)',
    nameKz: 'Цена (по возрастанию)',
  },
  orderByFieldId: RealPropertyListOrderFields.objectPrice,
  orderDirection: 'ASC',
});

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'По комнатам (по убыванию)',
    nameEn: 'По комнатам (по убыванию)',
    nameKz: 'По комнатам (по убыванию)',
  },
  orderByFieldId: RealPropertyListOrderFields.numberOfRooms,
  orderDirection: 'DESC',
});

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'По комнатам (по возрастанию)',
    nameEn: 'По комнатам (по возрастанию)',
    nameKz: 'По комнатам (по возрастанию)',
  },
  orderByFieldId: RealPropertyListOrderFields.numberOfRooms,
  orderDirection: 'ASC',
});

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'По площади (по убыванию)',
    nameEn: 'По площади (по убыванию)',
    nameKz: 'По площади (по убыванию)',
  },
  orderByFieldId: RealPropertyListOrderFields.totalArea,
  orderDirection: 'DESC',
});

RealPropertyListOrderOptions.push({
  label: {
    nameRu: 'По площади (по возрастанию)',
    nameEn: 'По площади (по возрастанию)',
    nameKz: 'По площади (по возрастанию)',
  },
  orderByFieldId: RealPropertyListOrderFields.totalArea,
  orderDirection: 'ASC',
});
